import { IndividualStagePointRule } from '../../../../../store/StageFile'

export const commentLengthIsValid: IndividualStagePointRule = (stagePoint) => {
    // In column G, text length must be between 1 and 19 chars inclusive
    if (stagePoint.comment.length > 19 || stagePoint.comment.length < 1) {
     //   return stagePointWarning(stagePoint, `Comment must be between 1 and 19 characters - "${stagePoint.Comment}" is ${stagePoint.Comment.length} characters`)
    } else {
        return undefined
    }
}